export const CARD_DESCRIPTION_DATA_SESSIONSTORAGE = 'CARD_DESCRIPTION_DATA_SESSIONSTORAGE';

export const CARD_DESCRIPTION_DATA_DEFAULT_STATE = {
    isCollapse: true,
};
